<template>
    <div class="tangeche tangeche-template-amy-or-betty">
        <div class="wrapper">
            <div class="module-title">最新车辆</div>
            <div class="module-desc">新车上架，每天都有新选择</div>
            <div class="module-more"><a href="/buy.htm" target="_blank">查看更多</a></div>
            <div class="module-body">
                <div class="show-card-wrapper">
                    <div class="car-item-container" v-for="item in carListComputed">
                        <a :href="'/car/' + item.id">
                            <div class="car-item"
                                is="CarItem"
                                :data="item"
                                :class="[ 'line-height-level-' + lineHeightLevel ]">
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CarItem from '@souche-f2e/wangzhan-dependencies-car-item/vue/Large.vue';
    import {
        getLineHeightLevel
    } from 'babel!@souche-f2e/wangzhan-dependencies-car-item/src/car-util.js';
    export default {
        props: ['carList'],
        computed: {
            carListComputed() {
                return this.carList;
            },
            lineHeightLevel() {
                let retNum = 0;
                let tangeche = false;
                let loan = false;
                for (var i = 0; i < this.carList.length; i++) {
                    let lineHeightLevel = getLineHeightLevel(this.carList[i]);
                    if (lineHeightLevel > retNum) {
                        retNum = lineHeightLevel;
                    }
                }
                return retNum;
            }
        },
        components: {
            CarItem
        }
    };
</script>

<style lang="less" scoped>
    .tangeche.tangeche-template-amy-or-betty {
        width: 100%;
        min-width: 1180px;
        background: #f5f5f5;
        padding-top: 77px;
        border-top: 1px #e9e9e9 solid;
        .wrapper {
            width: 1180px;
            margin: 0 auto;
        }
        .module-title {
            text-align: center;
            font-family: 'Microsoft YaHei';
            font-weight: 400;
            font-size: 32px;
            color: #4f4f4f;
            line-height: 50px;
        }
        .module-desc {
            text-align: center;
            font-family: 'Microsoft YaHei';
            font-size: 18px;
            color: #4f4f4f;
            line-height: 23px;
        }
        .module-more {
            text-align: center;
            font-family: 'Microsoft YaHei';
            font-size: 18px;
            color: #4f4f4f;
            line-height: 23px;
            a {
                display: block;
                width: 98px;
                height: 30px;
                border: #dadada 1px solid;
                margin: 20px auto 0;
                font-size: 14px;
                line-height: 30px;
                text-decoration: none;
                color: #989898;
                font-family: 'Microsoft YaHei';
            }
        }
        .module-body {

        }
        .show-card-wrapper {
            width: 1200px;
            padding: 55px 0;
            margin-left: -10px;
            position: relative;
            .car-item-container {
                margin: 0 20px 20px 0;
                float: left;
                & > a {
                    text-decoration: none;
                }
                .car-item {
                    // 无弹个车标且无售价 -22px -29px;
                    &.line-height-level-0 {
                        height: 372px - 22px - 29px;
                    }
                    // 无售价 -22px
                    &.line-height-level-1 {
                        height: 372px - 22px;
                    }
                    &.line-height-level-2 {
                        height: 372px;
                    }
                }
            }
            &:after {
                content: '';
                display: block;
                clear: both;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// TemplateAmyOrBetty.vue?c63ae15a